import * as Sentry from "@sentry/react";

/**
 * Logs errors to both internal API and Sentry
 * Called by Sentry ErrorBoundary when React rendering errors occur
 */
export const logError = (error, errorInfo, config) => {
    const { JANZU_URL } = config;

    // Log to internal event tracking API
    fetch(`${JANZU_URL}device-api/events`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            event_type: "reef_code_failure",
            source: "reef",
            description: [error.message, error.stack, window.location.href].join("\n"),
        }),
    }).catch(() => {
        // Silently fail if internal API is unavailable
    });

    if (Sentry.getClient()) {
        Sentry.withScope((scope) => {
            scope.setLevel("error");

            if (errorInfo?.componentStack) {
                scope.setContext("react_component_stack", {
                    componentStack: errorInfo.componentStack,
                });
            }

            scope.setContext("error_boundary_info", {
                source: "react_error_boundary",
                timestamp: new Date().toISOString(),
                viewport: {
                    width: window.innerWidth,
                    height: window.innerHeight,
                },
            });

            scope.setTag("error_boundary", "react");
            scope.setTag("error_type", "rendering_error");
            scope.setTag("caught_by", "error_boundary");

            scope.setFingerprint([
                "error-boundary",
                error.name,
                error.message,
            ]);

            Sentry.captureException(error);
        });
    }
};

